import Header from './Header'

function HeroHeader({ title, meta }) {
    return (
        <>
            <Header metaTitle={title} meta={meta} />
            <h1 className="py-16 bg-gradient-to-r from-olm to-olh text-white">
                <div className="container text-center font-bold text-6xl m-auto">
                    {title}
                </div>
            </h1>
        </>
    )
}

export default HeroHeader
